import React from 'react'

const Notification = () => {
  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00065 16.3333C7.91732 16.3333 8.66732 15.5833 8.66732 14.6666H5.33398C5.33398 15.5833 6.08398 16.3333 7.00065 16.3333ZM12.0007 11.3333V7.16658C12.0007 4.60825 10.6423 2.46659 8.25065 1.89992V1.33325C8.25065 0.641585 7.69232 0.083252 7.00065 0.083252C6.30898 0.083252 5.75065 0.641585 5.75065 1.33325V1.89992C3.36732 2.46659 2.00065 4.59992 2.00065 7.16658V11.3333L0.333984 12.9999V13.8333H13.6673V12.9999L12.0007 11.3333ZM10.334 12.1666H3.66732V7.16658C3.66732 5.09992 4.92565 3.41659 7.00065 3.41659C9.07565 3.41659 10.334 5.09992 10.334 7.16658V12.1666Z"
        fill="black"
      />
    </svg>
  );
}

export default Notification